<template lang="pug">
.audit-versions
  template(v-if="data.length !== 0")
    title-bar(style="margin-bottom: 20px") {{ $t('历史版本') }}
    el-row(style="margin-left: 20px")
      el-col(:span="15")
        template(v-for="item in data")
          audit-versions-item(:item = "item" :auditType="auditType")
</template>

<script>
import TitleBar from '@/components/TitleBar'
import AuditVersionsItem from './AuditVersionsItem'
import axios from 'axios'
export default {
  components: {
    AuditVersionsItem,
    TitleBar
  },
  data () {
    return {
      data: [],
      showContent: false
    }
  },
  props: {
    id: {
      type: Number
    },
    auditType: {
      type: Number,
      default: 5
    },
    businessType: {
      type: Number,
      default: 4
    }
  },
  mounted () {
    this.getApproveHistory()
  },
  methods: {
    async getApproveHistory () {
      try {
        this.data = await axios.get('/management/subfinal/getApproveHistory', {
          params: {
            id: this.id,
            business_type: this.businessType,
            audit_type: this.auditType
          }
        })
      } catch (err) {
        throw new Error(err)
      }
    }
  }
}
</script>

<style lang="stylus">
/*.audit-versions*/

</style>
